module.exports = __webpack_public_path__ + "img/te-13.e254a7cc.png";